import PageContainer from '@src/components/Layout/PageContainer'
import PageHeader from '@src/components/Layout/PageHeader'
import { useTranslation } from 'react-i18next'
import TeamDviTab from './TeamDviTab'

const DviPage = () => {
  const { t } = useTranslation()

  return (
    <>
      <PageHeader
        title={t('breadcrumbs.dvi')}
        breadcrumbs={{
          path: [{ href: '/dvi', label: t('breadcrumbs.dvi') }],
        }}
      />
      <PageContainer>
        <TeamDviTab />
      </PageContainer>
    </>
  )
}

export default DviPage
